'use strict';

var _ = require('lodash');
var SaveStrategyService = function SaveStrategyService(restangular, actionSerializer, conditionSerializer, configurationService, strategyRecordService, StrategyConstants, StrategyAction, $q, duplicateNameService, momentService, conditionsFilter, featureToggleService) {
  var saveStrategyAPI = restangular.one('rules');
  var strategyAPI = restangular.one('rules/strategy');
  function getUserId() {
    return configurationService.getUserId();
  }
  function retrieveStrategyNames() {
    return strategyAPI.get('').then(function (data) {
      return _.map(data.results, 'name');
    });
  }
  function saveStrategy(strategy, level, commonConditions) {
    var params = getStrategySaveRequestParams(strategy, level, commonConditions);
    return save(params);
  }
  function getStrategySaveRequestParams(strategy, level, commonConditions) {
    var currentTimestamp = strategy.eventTimeStamp || momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    var createdAt = strategy.createdAt || momentService.copy(currentTimestamp, momentService.FIELD.CREATED_AT);
    var createdDate = strategy.createdDate || momentService.copy(currentTimestamp, momentService.FIELD.CREATED_DATE);
    var strategyDetails = {
      name: strategy.name,
      description: strategy.description,
      basis: _.isUndefined(strategy.basis) ? 'custom' : strategy.basis,
      type: strategy.type,
      quickRule: strategy.quickRule || false,
      restricted: !strategy["public"],
      usage: _.isUndefined(strategy.usage) ? 0 : strategy.usage,
      createdBy: strategy.createdBy || getUserId(),
      createdAt: createdAt.toISOString(),
      createdDate: createdDate.toISOString(),
      eventTimeStamp: currentTimestamp.toISOString(),
      technicalId: strategy.technicalId,
      flowType: strategy.flowType
    };
    var statements = createStatements(strategy.groups, strategyDetails.type, strategyDetails.flowType, strategy.formulae);
    return prepareStrategySaveRequestParams(strategyDetails, statements, level, commonConditions);
  }
  function getStrategyFlowType(strategy) {
    return featureToggleService.isEnabled('MAPPED_MODE') && strategy.flowType ? strategy.flowType.replace(/FlowType./g, '') : undefined;
  }
  function strategyRestrictedToBoolean(strategy) {
    if (strategy && strategy.isRestricted && !_.isBoolean(strategy.isRestricted)) {
      strategy.isRestricted = strategy.isRestricted.toLowerCase() === 'yes';
    }
    return strategy;
  }
  function strategyRestrictedToString(strategy) {
    if (strategy && !_.isUndefined(strategy.isRestricted) && _.isBoolean(strategy.isRestricted)) {
      strategy.isRestricted = strategy.isRestricted ? 'Yes' : 'No';
    }
    return strategy;
  }
  function duplicateStrategy(strategy) {
    return getStrategyDuplicate(strategy).then(saveStrategyDuplicate);
  }
  function saveStrategyDuplicate(duplicate) {
    return save(duplicate).then(function (result) {
      duplicate.technicalId = result.technicalId;
      return duplicate;
    });
  }
  function getStrategyDuplicate(strategy) {
    var duplicateStrategyData = _.pick(strategy, ['description', 'basis', 'type', 'isRestricted', 'statements', 'commonConditions', 'isDsl', 'isQuickRule', 'flowType']);
    strategyRestrictedToBoolean(duplicateStrategyData);
    var currentTimestamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    var lastUpdatedAt = momentService.copy(currentTimestamp, momentService.FIELD.LAST_UPDATED_AT);
    var createdAt = momentService.copy(currentTimestamp, momentService.FIELD.CREATED_AT);
    var createdDate = momentService.copy(currentTimestamp, momentService.FIELD.CREATED_DATE);
    duplicateStrategyData.isDsl = true;
    duplicateStrategyData.createdBy = getUserId();
    duplicateStrategyData.lastUpdatedBy = getUserId();
    duplicateStrategyData.usage = 0;
    duplicateStrategyData.lastUpdatedAt = lastUpdatedAt.toISOString();
    duplicateStrategyData.createdAt = createdAt.toISOString();
    duplicateStrategyData.createdDate = createdDate.toISOString();
    duplicateStrategyData.eventTimeStamp = currentTimestamp.toISOString();
    return retrieveStrategyNames().then(function (names) {
      duplicateStrategyData.name = duplicateNameService.createNewName(strategy.name, names);
      return duplicateStrategyData;
    });
  }
  function save(strategySaveRequestParams) {
    return saveStrategyAPI.one('strategy').customPUT(strategySaveRequestParams);
  }
  function createStatements(groups, entityType, flowType, formulae) {
    var statements = [];
    groups.forEach(function (group) {
      var statement = {
        conditions: '',
        actions: [],
        level: ''
      };
      group.actions = _.filter(group.actions, function (action) {
        return action && !action.isEmpty();
      });
      group.actions.forEach(function (action) {
        Array.prototype.push.apply(statement.actions, actionSerializer.serialize(group.level, entityType, action));
      });
      group.conditions = _.filter(group.conditions, function (condition) {
        return !condition.isEmpty();
      });
      group.conditions = conditionsFilter.notAllOperandItemsSelected(group.conditions);
      statement.conditions = conditionSerializer.serialize(group.level, entityType, flowType, group.conditions);
      statement.level = group.level;
      if (formulae != null && formulae.length > 0) {
        statement.formulae = formulae;
      }
      statements.push(statement);
    });
    return statements;
  }
  function prepareStrategySaveRequestParams(strategyDetails, statements, level, commonConditions) {
    var lastUpdatedAt = momentService.now(momentService.FIELD.LAST_UPDATED_AT);
    var requestParams = {
      name: strategyDetails.name,
      description: strategyDetails.description,
      basis: strategyDetails.basis,
      type: strategyDetails.type,
      flowType: getStrategyFlowType(strategyDetails),
      lastUpdatedAt: lastUpdatedAt.toISOString(),
      lastUpdatedBy: getUserId(),
      usage: strategyDetails.usage,
      isRestricted: strategyDetails.restricted,
      isQuickRule: strategyDetails.quickRule,
      statements: statements,
      createdBy: strategyDetails.createdBy,
      createdAt: strategyDetails.createdAt,
      createdDate: strategyDetails.createdDate,
      eventTimeStamp: strategyDetails.eventTimeStamp,
      technicalId: strategyDetails.technicalId,
      isDsl: true
    };
    if (commonConditions) {
      commonConditions = conditionsFilter.notAllOperandItemsSelected(commonConditions);
    }
    if (commonConditions && commonConditions.length !== 0) {
      requestParams.commonConditions = conditionSerializer.serialize(level, requestParams.type, strategyDetails.flowType, commonConditions);
    }
    return requestParams;
  }
  return {
    saveStrategy: saveStrategy,
    duplicateStrategy: duplicateStrategy,
    strategyRestrictedToBoolean: strategyRestrictedToBoolean,
    strategyRestrictedToString: strategyRestrictedToString,
    getStrategySaveRequestParams: getStrategySaveRequestParams,
    getStrategyDuplicate: getStrategyDuplicate
  };
};
SaveStrategyService.$inject = ['Restangular', 'ActionSerializerService', 'ConditionSerializerService', 'ConfigurationService', 'StrategyRecordService', 'StrategyConstants', 'StrategyActionFactory', '$q', 'DuplicateNameService', 'MomentService', 'CriteriaValidateAndFilterService', 'FeatureToggleService'];
module.exports = SaveStrategyService;